import { render } from "./FeatherCameraSvg.vue?vue&type=template&id=2345e22c"
const script = {}
script.render = render

export default script